import React, { useState } from 'react'
 
 
 
import AccountGroupList from './AccountGroupList';
import AccountGroupForm from './AccountGroupForm';

const AccountGroup= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AccountGroupForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AccountGroupList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default AccountGroup